import * as React from "react";
import PropTypes from "prop-types";

function PaginationStatus({ pagination: { offset, limit, totalItems } }) {
  const start = offset + 1;
  const end = Math.min(offset + limit, totalItems);
  const total = totalItems;

  return (
    <div data-testid="AnalyticsSpa-PaginationStatus-Pagination">
      {totalItems > 0
        ? `Showing ${start}–${end} of ${total} results`
        : `Showing 0 results`}
    </div>
  );
}
PaginationStatus.propTypes = {
  pagination: PropTypes.shape({
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
  }).isRequired,
};

//@ts-ignore until typings in place
export default React.memo(PaginationStatus);
